import actions from './actions';
import getters from './getters';
import mutations from './mutations';

import { INITIAL_SCHEMA, INITIAL_CONFIG } from '@/helpers/dev';

export const dev = {
  namespaced: true,
  state: {
    schema: INITIAL_SCHEMA,
    initialSchema: INITIAL_SCHEMA,
    configLayout: INITIAL_CONFIG,
    modes: [],
    pages: [],
    navItems: [],
    parents: [],
    currentTemplate: 'templateHome',
    typeOfPageEditing: '',
    selectedPage: '',
    selected: {},
    selectedItem: {},
    currentMode: null,
    selectedTab: null,
    activeTab: null,
    selectedPortal: null,
    selectedEnvironment: null,
    confirmPageChanges: {
      dialog: false,
      origin: '',
      fileName: ''
    }
  },
  getters,
  mutations,
  actions
};
